import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {BarChart, ChartsLabelMark} from '@mui/x-charts';
import {useMemo} from "react";
import {XYVO} from "@/service/analyze";
import {find, map, omit} from "lodash";
import {BarSeriesType} from "@mui/x-charts/models/seriesType/bar";

const xDatas = [
    "1000以内",
    "1000-3000",
    "3000-5000",
    "5000-10000",
    "10000以上",
]

const yDatas: string[] = [
    "全款",
    "尾款",
    "分期"
]

export interface PaybackIntervalDistProps {
    intervalPayback: XYVO[]
    loading: boolean
}

export default function PaybackIntervalDist({intervalPayback, loading}: PaybackIntervalDistProps) {
    const series = useMemo(() => {
        const series: BarSeriesType[] = map(yDatas, (x) => {
            const data: number[] = xDatas?.map((y, i) => {
                const findData = find(intervalPayback, interval => interval.x == x)
                if (findData) {
                    const newItem = omit(findData, ['x'])
                    return newItem[`y${i + 1}`]
                } else {
                    return 0
                }
            })
            return {data: data || [], type: 'bar'}
        })
        return series
    }, [intervalPayback])

    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack alignContent={'start'} alignItems={'start'} direction={'row'} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        回款区间对比
                    </Typography>
                    <Stack alignItems={'start'} direction={'row'} spacing={1}>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'#ff0000'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>全款</Typography>
                        </Stack>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'yellow'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>分期</Typography>
                        </Stack>
                        <Stack alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={'green'}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>尾款</Typography>
                        </Stack>
                    </Stack>
                </Stack>
                <BarChart
                    height={180}
                    loading={loading}
                    localeText={{loading: "加载中"}}
                    xAxis={[{
                        data: xDatas, barGapRatio: 1, categoryGapRatio: 0.0,
                    }]}
                    series={series}
                    yAxis={[{width: 38, valueFormatter: (value: number) => `${value}次`, disableTicks: true, disableLine: true,}]}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                />
            </CardContent>
        </Card>
    );
}
